export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/AT-d5fa01f1313efed12605fcb13e47acd0.png";